import React from 'react';
import noResultImg from '../../../images/no-result.svg';
import './NoResult.css';

export const NoResult = ({ noGamesFound }) => {
    return <div className="no-result">
        <div className="no-result__icon">
            <img src={noResultImg} alt=""/>
        </div>
        <div className="no-result__text">
            {noGamesFound}
        </div>
    </div>;
};
